export const content = "No, there are no monthly fees to use BetterHelp. You can meet with your therapist as often as you need, and you'll only be charged after each session occurs.\n";
